export default __webpack_public_path__ + "static/media/tng.d74d1d13.png";